import { useSubscription } from '../../features/subscription/SubscriptionProvider';
import RecipeCard from '../RecipeCard/RecipeCard';
import styles from './RecipeList.module.scss';

const RecipeList = ({ recipes }) => {
  const { isSubscribed } = useSubscription();

  return (
    <article className={styles.container}>
      {recipes?.length ? (
        <>
          {recipes
            .sort((a, b) =>
              // When not subscribed sort by free first and then by featured.
              isSubscribed
                ? b.featured
                  ? 1
                  : -1
                : b.isFree
                ? 1
                : b.featured
                ? 1
                : -1
            )
            .map((recipe) => (
              <RecipeCard key={recipe._id} recipe={recipe} />
            ))}
        </>
      ) : (
        <section className={styles.noRecipesFound}>
          <p>Ingen oppskrifter funnet</p>
        </section>
      )}
    </article>
  );
};

export default RecipeList;
